
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'mnc-documents-shared-info-message',
    templateUrl: './shared-info-message.component.html',
    styleUrls: ['./shared-info-message.component.scss'],
    imports: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SharedInfoMessageComponent {
  @Input() title: string;
}
